import { CustomDirective } from "@/types/custom-directive";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Autofocus directive
 */
export const autofocusDirective: CustomDirective = {
  autofocus: {
    inserted: el => {
      el.focus();
    }
  }
};
